/**
 * Функция, которая читает параметр из маршрута и если его значение не определено `null`, то возвращает undefined
 * @param value
 */
export const fixRouteParam = (value: string | null): string | undefined => {
  return value === 'null' ? undefined : value ?? undefined;
};
